<template>
  <div>
    <V3CashOut v-if="showCashOut" :cashOutMoneyList="cashOutMoneyList" :typeId="typeId" @closecashout="closecashout"></V3CashOut>
    <div v-if="!showCashOut" id="v3RebateTypeMoneyDiv">
      <div id="v3ArrowDiv" @click="onBackClick()"><img id="v3Arrow" src="~assets/img/SdkV3/ArrowLeft.png" /></div>
      <div id="v3TitleDiv">
        提 现
      </div>
      <div style="display:flex;flex-direction:column;align-items: center;background-color: #F6F6F6;width: 85vw;padding-top: 5px;">
        <div v-for="(item, index) in $store.state.rebateTypeMoneyList" :key="index" :index="index + ''">
          <!-- {\"typeid\":1,\"money\":0.99,\"name\":\"登录红包\"} -->
          <div style="display:flex;flex-direction:row;align-items:center;width:78vw;height:50px;background-color: white;border-radius: 8px;padding-left: 5px;margin-top: 5px;position: relative;">
            <img v-if="item['name'] == '等级红包'" style="left:0%;width:35px;height:42px;" src="~assets/img/SdkV3/LevelRebate.png"/>
            <img v-else style="left:0%;width:35px;height:42px;" src="~assets/img/SdkV3/RebateIcon.png"/>
            <div style="height:42px;width:40vw;display:flex;flex-direction:column;justify-content:center;padding-left: 10px;">
              <span style="font-size:x-small">{{ item['money'] }}</span>
              <span style="font-size:xx-small">{{ item['name'] }}</span>
            </div>
            <button @click="showCashOutByType(item)">提 现</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/network/request';
import getRequestParams from "@/signParams";
import V3CashOut from './cashout/V3CashOut.vue'
export default {
  props:{
    
  },
  data() {
    return {
      showCashOut: false,
      cashOutMoneyList: [],
      typeId: ""
    }
  },
  components: {
    V3CashOut
  },
  methods:{
    closecashout(){
      this.showCashOut = false
    },
    onBackClick(){
      this.$store.commit('updateRebateTypeMoneyShowState', false)
    },
    showCashOutByType(item){
      console.log(item);
      this.typeId = item['typeid']
      // 根据typeid 获取对应的兑换额度列表
      let storeCommomParams = this.$store.state.commonParameters;
      storeCommomParams['typeid'] = this.typeId
      // console.log("基本参数 ： ", storeCommomParams);
      let signParams = getRequestParams({}, storeCommomParams);
      request({
          url: this.urls.REBATE_BONUS,
          params: {
            data: signParams // 在url后面加上&data=[signParams具体内容]
          },
        }).then(res => {
          console.log("金额接口返回", res);
          // bonus 红包兑换金额ID、 money 兑换金额（单位元）、 desc 红包兑换说明、 level 要求等级、 status 状态（1：可兑换，0：不可兑换）
          // [{"bonus":1,"money":1,"level":10,"desc":"1元兑换","status":0}]
          let bonusList = JSON.parse(res['bonusList'])
          if (bonusList.length < 1) {
            this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "没有兑换金额"})
            return
          }
          this.cashOutMoneyList = bonusList.filter((element) => {
              return element.status == '1'
          })
          this.showCashOut = true
        })
    },
  }
}
</script>

<style>
#v3RebateTypeMoneyDiv {
  position: relative;
  display: flex;
  flex-direction: column;
}

#v3TitleDiv {
  background-color: white;
  color: #3E3E3E;
  font-size: small;
  font-weight: bold;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #B4B4B4;
}

#v3ArrowDiv {
  position: absolute;
  float: left;
  height: 40px;
  display: flex;
  align-items: center;
}

#v3Arrow {
  height: 25px;
  width: 25px;
  object-fit: scale-down;
}


#v3RebateTypeMoneyDiv button{
  background: -webkit-linear-gradient(left, #FB6C34,#F84524);
  border-radius: 20px;
  padding-top: 3px;
  padding-bottom: 3px;
  /* height: 30px; */
  /* width: 94%; */
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 3px;
  padding-bottom: 3px;
  color: white;
  font-size: small;
  border: none;
  position: absolute;
  right: 8px;
}
</style>


// WEBPACK FOOTER //
// src/views/SdkV3/mine/rebateTypeMoney/V3RebateTypeMoney.vue